import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    
    // Namespace organization 
    ns: ['common', 'landing', 'navigation', 'dashboard', 'project', 'deliverables', 'tasks', 'actionPoints', 'checkPlan', 'gantt', 'settings', 'templates', 'feedback', 'notifications'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false, 
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: '1.2' },
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    debug: import.meta.env.DEV,
  });

// Keep html tag for seo compatibility
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = (lng || 'de').split('-')[0];
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
